// extracted by mini-css-extract-plugin
module.exports = {"apr":"Apy_apr__5XzKo","align_center":"Apy_align_center__1J6Iw","apr_green":"Apy_apr_green__1kLQg","apr_red":"Apy_apr_red__BMT9R"};